/**
 * Shared flag: the checkout is running as an OOB guest session
 * (the customer opened the checkout link shared by a CS operator).
 * Single source of truth for the `oobGuestCheckout` useState key —
 * always use this composable instead of re-declaring the key inline.
 */
export const useOobGuestCheckoutState = () =>
  useState<boolean>('oobGuestCheckout', () => false)
